<template>
  <div class="mainbox">
    <div style="width: 770px;" class="news_box">
      <div class="news_til">
        <div class="news_til_left_til">资讯新闻</div>
        <div class="news_til_left_eng">NEWS HEADLINES</div>
      </div>
      <div class="news_concent news_concent_new">
        <div class="news_concents">
          <div @click="goNext(`/gxGather/abroad/newsDetail?id=${item.id}`)" v-for="(item, index) in newsList"
            :key="index">
            <div></div>
            <div class="elp">{{ item.newTitle }}</div>
          </div>
        </div>
        <div>
          <img style="width: 190px;height: 136px;" src="~@/assets/img/TechnicalCollege/70.png" alt="">
          <img style="width: 190px;height: 136px;margin-top: 40px;" src="~@/assets/img/TechnicalCollege/72.png" alt="">
        </div>
        <!-- <div @click="goNext(`/gxGather/abroad/news?id=${id}`)" class="news_concents_bot">查看更多资讯新闻<img
            style="margin-left: 8px;width: 12px;height: 12px;" src="~@/assets/img/TechnicalCollege/24.png" alt=""></div> -->
      </div>
    </div>
    <div class="news_box">
      <div class="news_til">
        <div class="news_til_left_til">常见问题</div>
        <div class="news_til_left_eng">DECISION</div>

      </div>
      <div class="news_concent">
        <div class="news_concents quse">
          <div style="background: #F5F5F5;border-radius: 18px;padding: 2px 10px;" v-for="(item, index) in qusetionList"
            :key="index">
            <div v-show="false"></div>
            <div style="padding: 7px 12px;" class="elp">{{ item.questionName }}</div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Know } from "@/api/know";
import { loginSmsCode } from "@/api/login";
let know = new Know();
import { getDomain } from "@/api/cookies";
export default {
  components: {},

  data() {
    return {
      countDown: Date.now() + 1000 * 60,
      downTime: false,

      search: {
        pageSize: 15,
        pageNum: 1,
        projectTypeId: this.id
      },
      form: {},
      rules: {
        name: [{ required: true, message: " ", trigger: "blur" }],
        examStage: [{ required: true, message: " ", trigger: "blur" }],
        phone: [
          { required: true, message: " ", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: " ",
            trigger: "blur",
          },
        ],
        code: [{ required: true, message: " ", trigger: "blur" }],
        countryId: [{ required: true, message: " ", trigger: "change" }],
        schoolId: [{ required: true, message: " ", trigger: "change" }],
      },
      newsList: [],
      qusetionList: [],
      schoolList: [],
      countryList: [],
      projectType: '',
    };
  },
  created() {
    this.projectType = localStorage.getItem('projectType');
    this.search.projectTypeId = localStorage.getItem('projectTypeId');
    this.search.projectCategoryId = localStorage.getItem('projectCategoryId');
    know.getContentNewPcList({ ...this.search }).then((res) => {
      this.newsList = res.rows
    });
    know.getSchoolProblemPcList({
      pageSize: 6,
      pageNum: 1,
      projectTypeId: this.id
    }).then((res) => {
      this.qusetionList = res.rows
    });
    know.getStudyCountryPage({ pageSize: 999, pageNum: 1 }).then((res) => {
      this.countryList = res.rows
    });
    know.getStudyCountrySchoolPage({ pageSize: 999, pageNum: 1, countryId: this.form.countryId ? this.form.countryId : undefined, projectType: this.projectType }).then((res) => {
      this.schoolList = res.rows
    });

  },
  mounted() {

  },
  methods: {
    schoolChange() {
      this.form.schoolId = ''
      know.getStudyCountrySchoolPage({ pageSize: 999, pageNum: 1, countryId: this.form.countryId ? this.form.countryId : undefined, projectType: this.projectType }).then((res) => {
        this.schoolList = res.rows
      });
    },
    // 获取验证码
    async codeClick() {
      this.countDown = Date.now() + 1000 * 60;
      if (!this.form.phone) {
        this.$message.error("请先输入手机号");
        return;
      } else {
        const res = await loginSmsCode(this.form.phone, "welcomePotential");
        if (res.code === 0) {
          this.$message.success(res.msg);
          this.downTime = true;
        } else if (res.code === 500) {
          this.$message.error("请勿频繁获取！");
        }
      }
    },
    // 倒计时结束
    timeFinish(val) {
      if (val) return (this.downTime = false);
    },
    // 立即提交
    submitClick() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const foundItem = this.schoolList.find(item => item.id == this.form.schoolId);
          if (foundItem) {
            this.form.intentionSchool = foundItem.schoolName;
          } else {
            this.form.intentionSchool = ''
          }

          const res = await know.addStudyAbroadUserConsultation({
            studentName: this.form.name,
            mobile: this.form.phone,
            mobileToken: this.form.code,
            countryId: this.form.countryId,
            schoolId: this.form.schoolId,
            query: this.form.query,

            intentionSchool: this.form.intentionSchool,
            consultationClassify: localStorage.getItem("consultationClassify"),
            projectType: "5",
          });
          if (res.code === 0) {
            this.$message.success(res.msg);
            this.form = {}
            this.downTime = false
          } else {
            this.$message.error(res.msg);
          }
        } else {
          this.$message.error("请将信息填写完整 ！");
        }
      });
    },

  },
};
</script>

<style lang="less" scoped>
.mainbox {
  width: 1200px;
  margin: 0 auto;
  padding: 15px 0;
  display: flex;
  justify-content: space-between;

  .news_box {
    width: 406px;
    height: 390px;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    padding: 20px;

    .news_til {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      .news_til_left_til {

        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei-Bold;
        font-weight: normal;
        font-size: 20px;
        color: #333333;
        font-weight: bold;
        flex-shrink: 0;
      }

      .news_til_left_eng {
        margin-left: 5px;
        width: 100%;
        color: #9E96B5;
        // height: 26px;
        line-height: 24px;
        font-family: Helvetica, Helvetica;
        font-weight: normal;
        font-size: 13px;
        color: rgba(54, 72, 122, 0.5);
        border-bottom: 1px solid rgba(154, 163, 188, 0.5);
      }


    }

    .news_concent {
      width: 380px;
      height: 300px;
      overflow: hidden;
      border-radius: 4px 4px 4px 4px;
      margin-top: 13px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .news_concents {
        padding: 15px;

        >div {
          display: flex;
          align-items: center;

          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: normal;
          font-size: 14px;
          color: #444444;
          margin-bottom: 10px;
          cursor: pointer;

          >div:nth-child(1) {
            width: 7px;
            height: 7px;
            background: #BFA5CE;
            border-radius: 50%;
            margin-right: 10px;
            flex-shrink: 0;
          }

          >div:nth-child(2) {
            width: 300px;
          }
        }

        >div:hover {
          color: #BD1212;
        }
      }

      .news_concents_bot {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC-Regular, PingFangSC-Regular;
        font-weight: normal;
        font-size: 14px;
        color: #1061FF;
        cursor: pointer;
      }
    }

    .news_concent_new {
      width: 740px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .news_concents {
        width: 460px;


        >div {

          >div:nth-child(2) {
            width: 460px;
          }
        }
      }
    }
  }


  .apply_box {
    width: 370px;
    height: 390px;
    background: #EAEDFB;
    border: 1px solid #43528B;

    .apply_box_til {
      width: 100%;
      height: 40px;
      background: url('~@/assets/img/TechnicalCollege/42.png');
      background-size: 100% 100%;
      text-align: center;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei-Bold;
      font-weight: normal;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 40px;

    }

    .form {
      padding: 0 20px;
      margin: 38px 0;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 20px;

      input {
        width: 150px;
        height: 34px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #DDDDDD;
        padding: 0 10px;
      }

      input:nth-child(3),
      input:nth-child(4) {
        margin-top: 20px;
      }

      select {
        width: 150px;
        height: 34px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #DDDDDD;
        padding: 0 10px;
        margin-top: 20px;

      }


    }

    .apply_box_btn {
      width: 230px;
      height: 40px;
      background: #BC3535;
      border-radius: 21px 21px 21px 21px;
      font-family: PingFangSC-Regular, PingFangSC-Regular;
      font-weight: normal;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 40px;
      text-align: center;
      margin: 0 auto;
      cursor: pointer;
    }

    .apply_box_des {

      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: normal;
      font-size: 12px;
      color: #999999;
      text-align: center;
      margin: 0 auto;
      margin-top: 15px;
    }
  }
}

img {
  display: block;
  width: 100%;
  height: 100%;
}

.centent_form {
  // margin-top: 57px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  /deep/ .el-form-item:nth-last-child(1) {
    margin-right: 0;
  }

  /deep/ .el-input__suffix {
    right: 16px !important;
  }

  /deep/ .el-form-item {
    display: flex;
    justify-content: space-between;
    // margin-right: 10px;
    margin-bottom: 10px;

    .el-form-item__label {
      width: 90px;
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: normal;
      font-size: 14px;
      color: #666666;
    }

    .el-form-item__label::before {
      content: "";
      margin-right: 0;
    }

    .el-form-item__content {
      width: 222px;
      color: #848484 !important;

      // margin-left: 0px !important;
      .el-input {
        width: 100%;
        color: #848484 !important;

        .el-input__inner {
          width: 222px;
          height: 34px;
          background: #FFFFFF;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #DDDDDD;
          padding: 0 10px;
        }

        .yCode {

          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: normal;
          font-size: 12px;
          color: #1061FF;
          cursor: pointer;
        }

        .el-statistic {
          margin: 13px 5px 0 0;
        }

        .number {
          font-size: 12px;
          font-family: PingFangSC-Regular-, PingFangSC-Regular;
          font-weight: normal;
          color: #333333;
          letter-spacing: 1px;
        }
      }

      ::placeholder {
        color: #848484 !important;
      }

      // height: 30px;
      // border-radius: 30px;
    }
  }
}

.quse {
  >div:nth-child(1) {
    background: linear-gradient(270deg, #FBFBFB 0%, #FFB8B8 100%) !important;
  }

  >div:nth-child(2) {
    background: linear-gradient(270deg, rgba(251, 251, 251, 0) 0%, rgba(255, 184, 148, 0.5) 100%) !important;
  }

  >div:nth-child(3) {
    background: linear-gradient(270deg, rgba(251, 251, 251, 0) 0%, rgba(172, 158, 255, 0.5) 100%) !important;
  }
}
</style>